import './datepicker/datepicker-de.js';
import './parsley/de.js';
import './parsley/de.extra.js';
import './languageformat/languageformat.js';
